export default __webpack_public_path__ + "static/media/3.bf51e704.jpg";